import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { RouterModule, Routes }   from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LightboxModule } from 'ngx-lightbox';
import {
  MatListModule,
  MatInputModule,
  MatToolbarModule,
  MatButtonModule,
  MatCardModule,
  MatTabsModule,
  MatMenuModule
} from '@angular/material';

import { AppComponent } from './app.component';
import { ArtifactListComponent } from './artifact-list/artifact-list.component';
import { ArtifactDetailComponent } from './artifact-detail/artifact-detail.component';
import { ReferenceListComponent } from './references/reference-list.component';

import { ContentfulService } from './contentful.service';
import {MatGridListModule} from '@angular/material/grid-list';
import { CategoriesComponent } from './categories/categories.component';
import { ContactComponent } from './contact/contact.component';
import { HomeComponent } from './home/home.component';


// check this and make a module out of it
const routes: Routes = [
  { path: '', component: HomeComponent  },
  { path: 'portfolyo',  component: ArtifactListComponent },
  { path: 'categoriler/portfolyo/:categoryid',  component: ArtifactListComponent },
  { path: 'categoriler/portfolyo/:slug', component: ArtifactDetailComponent },
  { path: 'referanslar',  component: ReferenceListComponent },
  { path: 'categoriler',  component: CategoriesComponent },
  { path: 'iletisim',  component: ContactComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    ArtifactListComponent,
    ArtifactDetailComponent,
    ReferenceListComponent,
    CategoriesComponent,
    ContactComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    FormsModule,
    MatListModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    MatGridListModule,
    MatMenuModule,
    LightboxModule
  ],
  exports: [
    MatListModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    MatGridListModule
  ],
  providers: [ContentfulService],
  bootstrap: [AppComponent]
})
export class AppModule { }
